//DUPLICATE: @testsigmainc/models/application.model.ts
import { ApplicationType } from '@testsigmainc/constants';
import { custom, deserialize, optional, serializable } from 'serializr';
import { ApplicationVersion } from './application-version.model';
import { Base } from './base.model';
import { PageObject } from './page-object.model';
import { Project } from './project.model';

export class Application extends Base implements PageObject {
  @serializable
  public name: string;
  @serializable
  public description: string;
  @serializable
  public projectId: number;
  @serializable
  public applicationType: ApplicationType;
  @serializable
  public createdById: number;
  @serializable
  public updatedById: number;
  @serializable(
    custom(
      (v) => {
        if (v) {
          const versions = [];
          v.forEach((version) => {
            versions.push(version.serialize());
          });
          return versions;
        }
      },
      (v) => {
        if (v) {
          const versions: ApplicationVersion[] = [];
          v.forEach((version) => {
            versions.push(new ApplicationVersion().deserialize(version));
          });
          return versions;
        }
      },
    ),
  )
  public applicationVersions: ApplicationVersion[];

  @serializable(
    optional(
      custom(
        (v) => v,
        (v) => v,
      ),
    ),
  )
  public project: Project;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(Application, input));
  }

  get isMobileNative() {
    return (
      this.applicationType == ApplicationType.AndroidNative ||
      this.applicationType == ApplicationType.IOSNative
    );
  }

  get isAndroidNative() {
    return this.applicationType == ApplicationType.AndroidNative;
  }

  get isIosNative() {
    return this.applicationType == ApplicationType.IOSNative;
  }

  get isWeb() {
    return this.applicationType == ApplicationType.WebApplication;
  }

  get isMobile() {
    return this.isMobileWeb || this.isMobileNative;
  }

  get isDesktopWindows() {
    return this.applicationType == ApplicationType.WINDOWS;
  }

  get isDesktopMac() {
    return this.applicationType == ApplicationType.WINDOWS; //TODO Hide later we support Jayavel
  }

  get isDesktopApp() {
    return this.isDesktopMac || this.isDesktopWindows;
  }

  get isRest() {
    return this.applicationType == ApplicationType.Rest;
  }

  get isMobileWeb() {
    return this.applicationType == ApplicationType.MobileWeb;
  }

  get isWebMobile() {
    return (
      this.applicationType == ApplicationType.MobileWeb ||
      this.applicationType == ApplicationType.WebApplication
    );
  }
  get isSalesforce() {
    return this.applicationType == ApplicationType.Salesforce;
  }

  get isWindowsAdvanced() {
    return this.applicationType == ApplicationType.WINDOWS_ADVANCED;
  }

  get isWebMobileOrSalesforce() {
    return this.isWebMobile || this.isSalesforce;
  }

  get isImportSupported() {
    return (
      this.applicationType == ApplicationType.MobileWeb ||
      this.applicationType == ApplicationType.WebApplication ||
      this.applicationType == ApplicationType.AndroidNative ||
      this.applicationType == ApplicationType.IOSNative ||
      this.applicationType == ApplicationType.Rest
    );
  }

  get isAccessibilitySupported() {
    return (
      this.applicationType == ApplicationType.AndroidNative ||
      this.applicationType == ApplicationType.IOSNative ||
      this.applicationType == ApplicationType.WebApplication
    );
  }
}
